import React from 'react';
import { Text } from 'components/ui';
import FramworkUtils from 'utils/framework';
import localeUtils from 'utils/LanguageLocale';
import StoreHoursEN from 'components/Stores/StoreDetails/locales/StoreHours_en_US';
import StoreHoursFR from 'components/Stores/StoreDetails/locales/StoreHours_fr_CA';

const { wrapFunctionalComponent } = FramworkUtils;
const getText = localeUtils.getLocalisedDataFromResource(StoreHoursEN, StoreHoursFR);

function StoreHours({ storeHoursDisplay, todayClosingTime, hasBoldedDay = true, displayTodayClosingTime = true }) {
    const tag = hasBoldedDay ? 'b' : 'span';

    return (
        <div data-at={Sephora.debug.dataAt('store_hours')}>
            {todayClosingTime && displayTodayClosingTime && (
                <div css={{ marginBottom: '.5em' }}>
                    <b>{getText('hours')} -</b> {getText('openTodayUntil')}
                    {' ' + todayClosingTime}
                </div>
            )}
            {storeHoursDisplay &&
                storeHoursDisplay.length &&
                storeHoursDisplay.map(storeDisplay => (
                    <div
                        key={storeDisplay.dayRange}
                        data-at={Sephora.debug.dataAt('store_hours_label')}
                    >
                        <Text
                            is={tag}
                            width={65}
                        >
                            {storeDisplay.dayRange}
                        </Text>
                        : {storeDisplay.hours}
                    </div>
                ))}
        </div>
    );
}

export default wrapFunctionalComponent(StoreHours, 'StoreHours');
